import icon from 'vue-svgicon';

icon.register({
    'bold/currency-dollar': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M18.133 16.1a4.79 4.79 0 0 0-3.028-4.47l-5.1-2.039a1.815 1.815 0 0 1 .675-3.5h5.023a1.5 1.5 0 0 0 0-3H13.75a.25.25 0 0 1-.25-.25V1.5a1.5 1.5 0 0 0-3 0v1.371a.25.25 0 0 1-.228.25A4.8 4.8 0 0 0 8.9 12.373l5.1 2.039a1.815 1.815 0 0 1-.675 3.5H8.294a1.5 1.5 0 0 0 0 3h1.956a.25.25 0 0 1 .25.25V22.5a1.5 1.5 0 0 0 3 0v-1.371a.25.25 0 0 1 .228-.25 4.81 4.81 0 0 0 4.405-4.779z"/>`,
    },
});
